import _ from 'lodash'

export const PEOPLE_QUERY_RULES = Object.freeze({
  adult: Object.freeze({ min: 1, max: 100, default: 1 }),
  child: Object.freeze({ min: 0, max: 100, default: 0 }),
  infant: Object.freeze({ min: 0, max: 30, default: 0 })
})

const INTEGER_VALID_RULE = /^\d+$/

/**
 * 驗證 URL query 的人數參數（adult/child/infant）
 * 任一參數違反規則就fallback為預設值；
 * 未帶或空字串視為未指定，不算違反（沿用既有行為）
 * @param {Object} query - this.$route.query
 * @returns {{ invalidEntries: String[], people: { adult: Number, child: Number, infant: Number } }}
 */
export function validatePeopleQuery (query = {}) {
  const invalidEntries = []

  const people = _.mapValues(PEOPLE_QUERY_RULES, (rule, field) => {
    const rawValue = query[field]
    if (rawValue === undefined || rawValue === '') return rule.default

    const numberValue = Number(rawValue)
    const isValid = INTEGER_VALID_RULE.test(rawValue) &&
      numberValue >= rule.min &&
      numberValue <= rule.max
    if (!isValid) invalidEntries.push(`${field}=${rawValue}`)

    return isValid ? numberValue : rule.default
  })

  return {
    invalidEntries,
    people: invalidEntries.length ? _.mapValues(PEOPLE_QUERY_RULES, 'default') : people
  }
}
